import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Resizable } from "re-resizable";
import { faCheckCircle, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import RoomIcon from '@material-ui/icons/Room';
import { NavLink, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCloudUploadAlt, faInfoCircle, faExclamationCircle, faFlag, faCheck } from '@fortawesome/free-solid-svg-icons';
import { clearCookie, getPrivileges } from '../../../functions/Auth';
import Cookies from 'js-cookie';
import API_PATH from "../../../constants/config.json";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

//This code use for resizable panel ui ...start
const style = {
    display: "block",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    float: 'left',
    top: '-14px',
  };
  //This code use for resizable panel ui ...end

const useStyles = makeStyles((theme) => ({
    locationParaSizeExceeds: {
        margin: '0',
        '& input': {
          width: '75%',
          float: 'left',
          border: '1px solid #D7D7D7',
        }
    },
    locationIconErrorSizeExceeds: {
        color: '#D7D7D7',
        paddingRight: '5px',
        width: '15%',
        float: 'left',
        cursor: 'pointer',
        '& .MuiSvgIcon-root': {
          verticalAlign: 'sub',
          fontSize: '20pt',
        }
    },
    errorStatus: {
        color: '#CC0000',
        margin: '0',
        '& .statusIcon': {
          verticalAlign: 'middle',
          paddingRight: '7px',
          position: 'relative',
          top: '1px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20px',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
          },
        }
    },
    warningStatus: {
        margin: '0',
        '& .statusIcon': {
          color: '#CC9900',
          verticalAlign: 'middle',
          paddingRight: '7px',
          position: 'relative',
          top: '1px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20px',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
          },
        }
    },
    fileListBlock: {
        width: '100%',
        background: '#fff',
        padding: '10px',
        position: 'fixed',
        bottom: '22px',
        zIndex: '9',
        maxHeight: '78% !important',
        borderTop: '1px solid #24618E',
        '@media only screen and (max-width: 1279px)': {
          width: '100% !important',
          position: 'absolute !important',
          bottom: '22px !important',
        },
        '& h3': {
          color: '#24618E',
          marginTop: '5px',
          marginBottom: '0px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '30pt',
          },
        },
        '& table': {
          width: '100%',
          textAlign: 'left',
          borderCollapse: 'collapse',
          '& th': {
            border: '1px solid #d1d1d1',
            padding: '5px',
            backgroundColor: '#fff',
            '@media only screen and (max-width: 3500px)': {
              fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
              fontSize: '24pt',
            },
          },
          '& td': {
            border: '1px solid #d1d1d1',
            padding: '5px',
          },
          '& tr:nth-child(odd)': {
            backgroundColor: '#f2f2f2'
          },
        },
        '& .importList-left': {
          width: '85%',
          float: 'left',
        },
        '& .importList-right': {
          width: '15%',
          float: 'right',
          textAlign: 'center',
        }
    },
    useStationDataBlockRight: {
        width: '20%',
        float: 'left',
        textAlign: 'center',
    },
    resizeBlock: {
        textAlign: 'center',
        width: '120px',
        margin: '-17px auto 0',
        border: '1px solid #24618E',
        borderBottom: 'none',
        background: '#fff',
        color: '#24618E',
        position: 'relative',
        lineHeight: '15px',
        borderRadius: '5px 5px 0 0',
        paddingTop: '2px',
        '& span': {
          position: 'relative',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '25pt',
            top: '4px',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '35pt',
            top: '8px',
          },
        }
    },
    borderImg: {
        width: '100%',
        height: '2px',
    },
    importedMsg: {
        background: '#DFF0D8',
        margin: '0',
        padding: '5px 5px 3px 5px',
        width: '97%',
        border: '1px solid #006600',
        borderRadius: '4px',
        color: '#333',
        '& svg': {
        color: '#006600',
        fontSize: '20pt',
        verticalAlign: 'sub',
        marginRight: '10px',
        }
    },
    importedErrorMsg: {
        background: '#F2DEDE',
        margin: '0',
        marginBottom: '10px',
        padding: '5px 5px 3px 5px',
        width: '97%',
        border: '1px solid #CC0000',
        borderRadius: '4px',
        color: '#CC9900',
        '& svg': {
        color: '#CC0000',
        fontSize: '20pt',
        verticalAlign: 'sub',
        marginRight: '10px',
        }
    },
    importedWarningMsg: {
        background: 'rgba(252, 248, 227, 1)',
        margin: '0',
        marginBottom: '10px',
        padding: '5px 5px 3px 5px',
        width: '100%',
        border: '1px solid #CC9900',
        borderRadius: '4px',
        color: '#333',
        '& svg': {
        color: '#CC9900',
        fontSize: '20pt',
        verticalAlign: 'sub',
        marginRight: '10px',
        }
    },
    loaderBlock: {
        width: '50%',
        float: 'left',
        border: '1px solid #006600',
        borderRadius: '5px',
        padding: '10px',
        '& .loader-left': {
        width: '15%',
        float: 'left',
        '& img': {
            width: '75%',
        }
        },
        '& .loader-right': {
        width: '80%',
        float: 'left',
        }
    },
    importedFilesTable: {
        '& th': {
          textAlign: 'center',
        }
    },
    cancelUseThisStation: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        '@media only screen and (max-width: 3500px)': {
        width: '175px',
        },
        '@media only screen and (min-width: 3501px)': {
        width: '275px',
        },
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    useThisStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        fontSize: '12px',
        '@media only screen and (max-width: 3500px)': {
        width: '175px',
        },
        '@media only screen and (min-width: 3501px)': {
        width: '275px',
        },
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    useThisStationBtnDesabled: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        '@media only screen and (max-width: 3500px)': {
        width: '175px',
        },
        '@media only screen and (min-width: 3501px)': {
        width: '275px',
        },
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    aadMoreFiles: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        fontSize: '12px',
        '@media only screen and (max-width: 3500px)': {
        width: '170px',
        },
        '@media only screen and (min-width: 3501px)': {
        width: '260px',
        },
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    addMoreBtnMain: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        padding: '10px 20px',
        textDecoration: 'none',
        borderRadius: '5px',
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    aadMoreFilesDesabled: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        '@media only screen and (max-width: 3500px)': {
        width: '170px',
        },
        '@media only screen and (min-width: 3501px)': {
        width: '260px',
        },
        '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        }
    },
    importDatabtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        '@media only screen and (max-width: 3500px)': {
          width: '170px',
        },
        '@media only screen and (min-width: 3501px)': {
          width: '260px',
        },
        '&:hover': {
          boxShadow: '4px 3px 3px 0px #999',
        }
    },
    fileIcon: {
        color: '#333',
        fontWeight: 'normal',
        verticalAlign: 'middle',
        '@media only screen and (max-width: 3500px)': {
        fontSize: '26px',
        },
        '@media only screen and (min-width: 3501px)': {
        fontSize: '28pt',
        },
    },
    locationIconSuccess: {
        color: '#333',
        paddingRight: '5px',
        float: 'left',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
          width: '15%',
        },
        '@media only screen and (min-width: 3501px)': {
          width: '12%',
        },
        '& .MuiSvgIcon-root': {
          '@media only screen and (max-width: 3500px)': {
            verticalAlign: 'sub',
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            verticalAlign: 'middle',
            fontSize: '28pt',
          },
        }
    },
    locationIconWarning: {
        color: '#CC9900',
        paddingRight: '5px',
        float: 'left',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
          width: '15%',
        },
        '@media only screen and (min-width: 3501px)': {
          width: '12%',
        },
        '& .MuiSvgIcon-root': {
          '@media only screen and (max-width: 3500px)': {
            verticalAlign: 'sub',
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            verticalAlign: 'middle',
            fontSize: '28pt',
          },
        }
    },
    locationPara: {
        margin: '0',
        '& input': {
          width: '70%',
          float: 'left',
          border: '1px solid #CC0000',
        },
        '& input.successinput': {
          border: '1px solid #333 !important',
        },
        '& input.warninginput': {
          border: '1px solid #CC9900 !important',
        }
    },
    importSearchField: {
        '& .esri-search__suggestions-menu': {
          visibility: 'hidden !important'
        },
        '& .esri-search__sources-menu': {
          maxHeight: '158px !important'
        }
    },
    useStationDataBlockLeft: {
        border: '1px solid #00A75D',
        borderRadius: '5px',
        padding: '10px',
        // height: '225px',
        minHeight: '258px',
        width: '78%',
        float: 'left',
        '& input': {
          width: '100% !important',
        },
        '& p': {
          margin: '0',
          marginBottom: '10px',
          float: 'left',
          width: '100%',
        },
        '& .span-left': {
          width: '18%',
          float: 'left',
        },
        '& .span-right': {
          float: 'left',
          width: '80%',
        },
        '& .useStatusCaps': {
          textTransform: 'capitalize',
        }
    },
    textField: {
        display: 'flex',
        backgroundColor: '#fff',
        marginLeft: '10px',
        width: '80%',
        '& fieldset': {
          border: '1px solid #24618E !important',
          height: '43px',
        },
        '& .esri-search': {
          width: '100%'
        },
        '& .esri-search__submit-button': {
          position: 'relative',
          width: '40px',      
          color: ' #fff',
          border: '1px solid #24618E',
          fontSize: '20px',
          background: '#24618E',
          textAlign: 'center',
          padding: '5px',
          borderRadius: '0px 5px 5px 0px',
          cursor: 'pointer',
          height: '38px',
        },
        '& .esri-search__input': {
          '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt !important'
          },
        },
        '& .esri-input[type="text"]': {
          '@media only screen and (max-width: 3500px)': {
            height: '35px'
          },
          '@media only screen and (min-width: 3501px)': {
            height: '55px',
            fontSize: '22pt !important'
          },
        },
        '& .esri-search__suggestions-menu': {
          width: '93%',
          top: '94% !important',
          border: '1px solid #24618E'
        },
        '& .esri-menu__list-item': {
          borderTop: 'none'
        },
        '& .esri-icon-search': {
          fontWeight: '900',
          fontSize: '20px',
          color: '#fff !important'
        },
        '& .esri-search__submit-button.esri-widget--button': {
          background: ' #24618E !important',
          color: '#fff !important'
        },
        '& .esri-search__form': {
          border: '1px solid #24618E',
          borderRadius: '0px',      
          borderBottomRightRadius: '0px',
          borderRight: 0,
          borderLeft: 0,
        },
        '& .esri-menu__list-item:hover': {
          backgroundColor: '#24618E',
          color: '#fff'
        },
        '& .esri-search__clear-button': {
          color: '#24618E',
          marginTop: '0px',
          height: '38px',
          border: '1px solid #24618E',
          borderLeft: '0px',
        },
        '& .esri-icon-close': {
          fontWeight: 'bold',
          fontSize: '13px'
        },
        '& .esri-search__sources-button': {
          height: '38px',
          border: '1px solid #24618E',
          borderRadius: ' 5px 0px 0px 5px',
          width: '38px'
        },
        '& .esri-icon-down-arrow:before': {    
        }
    },
    removeIcon: {
        fontSize: '20pt',
        verticalAlign: 'middle',
        color: '#333',
        fontWeight: '600',
        fontFamily: "Avenir_Black",
        '& :hover': {
          color: '#cc0000',
        }
    },
    locationIconError: {
        color: '#CC0000',
        paddingRight: '5px',
        float: 'left',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
          width: '15%',
        },
        '@media only screen and (min-width: 3501px)': {
          width: '12%',
        },
        '& .MuiSvgIcon-root': {
          '@media only screen and (max-width: 3500px)': {
            verticalAlign: 'sub',
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            verticalAlign: 'middle',
            fontSize: '28pt',
          },
        }
    },
}));

let bcktName;
let uploadRetryCount = 0;
let s3UploadStatus = false;

const ImportList = props => {
    const classes = useStyles();
    let history = useHistory();
    const [blockHeight, setBlockHeight] = React.useState('auto');
    const [autoAdjustHeight, setAutoAdjustHeight] = React.useState(300);
    const [fileUploadError, setFileUploadError] = React.useState('The following files did not properly import to DataPoint');
    const [agencyBucket, setAgencyBucket] = React.useState('');
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [importloaderShow, setImportloaderShow] = React.useState('none');
    const [selectedFileName, setSelectedFileName] = React.useState(null);
    const [getAllFilesSelected, setAllFilesSelected] = React.useState(false);

    let warningStatus = <p className={classes.warningStatus}><span className="statusIcon"><FontAwesomeIcon icon={faFlag} /></span>Warning</p>;
    let errorStatus = <p className={classes.errorStatus}><span className="statusIcon"><FontAwesomeIcon icon={faExclamationCircle} /></span>Error</p>;
    let importBtnStatus = 1;

    useEffect(() => {
        if (getPrivileges().length !== 0) {
            getBucket();
            getAswToken();
        }
    }, [])

    //This Function is used for get bucket name
    const getBucket = () => {
        try {
        axios({
            method: 'post',
            url: API_URL + API_PATH.getAWSs3BucketAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            bcktName = response.data;
            bcktName = bcktName.data;
            bcktName = bcktName.bucket_name;
            setAgencyBucket(bcktName);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }

    //This Function is used for ASW S3 Token
    let aswData;
    const getAswToken = () => {
        try {
        axios({
            method: 'get',
            url: API_URL + API_PATH.getAWSs3TokenAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            aswData = response.data;
            aswData = aswData.data;
            setIdintityPool(aswData.IdentityPoolId);
            setAswLogins(aswData.Logins);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }
    //This Function is used for ASW S3 Token

    //This Function is used for get bucket name
    const checkBlockHeight = () => {
        let divHeight;
        divHeight = document.getElementById('mainFileBlock-dev').clientHeight;
        divHeight = divHeight - 120;
        setAutoAdjustHeight(divHeight)
    }

    //S3 file Responce
    function listObjs(bucket) {
        return new Promise((resolve, reject) => {
        let prefix = Cookies.get('email');
        bucket.listObjects({
            Prefix: prefix
        }, function (err, data) {
            if (err) {
            console.log('ERROR: ' + err);
            } else {
            let objKeys = "";
            data.Contents.forEach(function (obj) {
                objKeys = obj.Key;
            });
            console.log(objKeys);
            resolve(true);
            }
        });
        })
    }
    // S3 file Responce  

    //This method is use for remove imported file from greed ... start
    const removeUploadedFile = (fileIndex = []) => {
        let tempArray = [];
        if (fileIndex.length > 0) {
            for (let i = 0; i < props.details.length; i++) {
                let indexFile = fileIndex.findIndex((uniqueID, index) => uniqueID === props.details[i].uniqueID)
                if (indexFile === -1) {
                tempArray.push(props.details[i]);
                }
            }
            props.setDetails(tempArray);
        }
    }
    //This method is use for remove imported file from greed ... end

    //This method is use for import file data on import button click ... start
    const importFileData = async () => {   
        let details = props.details;
        let fileIndex = [];
        let batchIDArray = [];
        let file_ids;
        let OIDToken = Cookies.get('idToken');
        let bucketName = agencyBucket;
        AWS.config.region = 'us-west-2'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: idintityPool,
        Logins: {
            [aswLogins]: OIDToken
        }
        });

        let bucket = new AWS.S3({
        params: {
            Bucket: bucketName
        }
        });

        props.setShowimportData('none');
        setImportloaderShow('block');

        // getting max batch id 
        try {
          //this code is import datafile for import list
          await axios({
            method: 'post',
            url: API_URL + API_PATH.getMaxBatchId,
            headers: {
                'agencyid': sessionStorage.getItem('agency_id'),
                'payload': Cookies.get('payload'),
            },
          }).then(async function (response) {
            if (response.status && response.status == '200') {
              let resp = response.data;
              let maxBatchId = resp.data[0] ? resp.data[0].nextval : null;
              for (let i = 0; i < details.length; i++) {
                //This Code is Used for Data file
                let fileStatusId = details[i].file_status_id;
                let fileTId = details[i].file_type_id;
                let originName = details[i].fileName;
                let sid = details[i].station_id;
                let username = Cookies.get('email');
                let objKey;
                let timeStams = new Date().getTime();
                let fileExe = details[i].file_exe;     
                objKey = username + '/' + details[i].fileName.replace(/(\.[\w\d_-]+)$/i, '_' + timeStams + '$1');
                let params = {
                    Key: objKey,
                    ContentType: details[i].file_exe,
                    Body: details[i].file_body
                };
                await bucket.putObject(params, async function (err, data) {             
                    if (err && err.message) {
                    //setTimeout(async function () {
                        if (uploadRetryCount !== 3 && !s3UploadStatus) {   
                        uploadRetryCount = uploadRetryCount + 1;           
                        await importFileData();
                        props.setShowimportData('none');
                        setImportloaderShow('block');
                        }
                        else {
                        setFileUploadError(err.message);
                        setImportloaderShow('none');
                        props.setShowimportData('block');
                        props.setImportResponceValue(1);
                        }
                    // }, 500);
                    } else {
                    s3UploadStatus = true;
                    try {
                        //this code is import datafile for import list
                        await axios({
                        method: 'post',
                        data: {
                            file_status_id: fileStatusId,
                            file_type_id: fileTId,
                            origin_name: originName,
                            base_name: objKey,
                            station_id: sid,
                            username: username,
                            batch_id: maxBatchId,
                            bucket_name: bucketName
                        },
                        url: API_URL + API_PATH.dataFileAPI,
                        headers: {
                            'agencyid': sessionStorage.getItem('agency_id'),
                            'payload': Cookies.get('payload'),
                        },
                        }).then(async function (response) {
                        if (response.status && response.status == '200') {
                            fileIndex.push(details[i].uniqueID);
                            file_ids = response.data.file_id;
                            batchIDArray.push(file_ids);
                            await listObjs(bucket).then(async result => {
                            if (i === details.length - 1) {
                                setImportloaderShow('none');
                                props.setShowimportData('block');
                                // await removeMatchLocation();
                                await props.importRemoveLocation();
                                // await removeAllMapLocations();
                                // tempView.graphics.removeAll();
                                props.setMapLocation([]);
                                if (fileIndex.length > 0) {
                                if (fileIndex.length === details.length) {
                                    props.setImportResponceValue(2);
                                    props.setDetails([]);
                                    // await setBatchId(batchIDArray, maxBatchId);
                                    uploadRetryCount = 0;
                                    s3UploadStatus = false;
                                }
                                else {
                                    await removeUploadedFile(fileIndex);
                                    // await setBatchId(batchIDArray, maxBatchId);
                                    props.setImportResponceValue(1);
                                    uploadRetryCount = 0;
                                    s3UploadStatus = false;
                                }
                                }
                            }
                            }).catch(err => {
                            console.log(err)
                            })
                        } else {
                            console.log("Data file no import");
                        }
                        }).catch(async function (error) {
                        if (error.response) {
                            if (error.response.status && error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                            }
                        }
                        props.setImportResponceValue(1);
                        })
                    } catch (error) {
                        console.error(error);
                    }
        
                    }
                });     
              }
            } else {
              console.log("No batch id returned");
            }
          });
        } catch (error) {
            console.error(error);
        }
    }
    //This method is use for import file data on import button click ... end

    const allFilesSelected = async () => {
        // props.setImportDataMapPoint(true);
        // tempView.graphics.removeAll();
        setSelectedFileName(null);
        setAllFilesSelected(true);
        props.callAllMapLocations();
    }

    const getImportWarning = () => {
        for (let i = 0; i < props.details.length; i++) {
          if (props.details[i].file_status == 'success' && props.details[i].file_size_status == 'warning') {
            return true;
          }
        }
    }

    //This function is work for remove current row of table start
    const removeRow = (e, item) => {
        props.details.splice(item, 1);
        props.removeAllMapLocations();
        props.importRemoveLocation();
    }
    //This function is work for remove current row of table end

    //This method is use for on input change for station selection on greed .... start 
    let st_cl_id;
    const onInputChange = (e, i) => {
        let importStationId = props.importStationId;
        let details = props.details;
        st_cl_id = e.target.value;
        let items = props.stationDetails;
        let data;
        let ssId;

        let newArrTemp = [...details];
        newArrTemp[i] = {
        uniqueID: details[i].uniqueID,
        station_id: 0,
        status: errorStatus,
        fileName: details[i].fileName,
        sationId: st_cl_id,
        dataType: details[i].dataType,
        vendor: details[i].vendor,
        file_status: 'error',
        file_type_id: details[i].file_type_id,
        file_body: details[i].file_body,
        file_exe: details[i].file_exe,
        file_size_status: details[i].file_size_status,
        import_Status: 'ready',
        file_status_id: details[i].file_status_id
        };
        props.setDetails(newArrTemp);
        props.removeAllMapLocations();
        props.afterLocationSelect(newArrTemp);

        try {
        // data = items.filter(item => item.stationId === st_cl_id);
        data = importStationId ? items.filter(item => item.stationId === importStationId) : items.filter(item => item.stationId === st_cl_id);
        ssId = data[0].station_id;
        let newArr = [...details];
        newArr[i] = {
            uniqueID: details[i].uniqueID,
            station_id: ssId,
            status: importStationId && items.some(item => item.stationId === st_cl_id) && importStationId !== st_cl_id ? warningStatus : importStationId && importStationId !== st_cl_id ? errorStatus : 'Queued',
            fileName: details[i].fileName,
            sationId: st_cl_id,
            dataType: details[i].dataType,
            vendor: details[i].vendor,
            file_status: importStationId && items.some(item => item.stationId === st_cl_id) && importStationId !== st_cl_id ? 'success' : importStationId && importStationId !== st_cl_id ? 'error' : 'success',
            file_type_id: details[i].file_type_id,
            file_body: details[i].file_body,
            file_exe: details[i].file_exe,
            file_size_status: importStationId && items.some(item => item.stationId === st_cl_id) && importStationId !== st_cl_id ? 'warning' : 'success',
            import_Status: 'ready',
            file_status_id: details[i].file_status_id
        };
        props.setDetails(newArr);
        props.removeAllMapLocations();
        props.afterLocationSelect(newArr);
        } catch (error) {
        //Throw Error
        }
    };
    //This method is use for on input change for station selection on greed .... end

    const returnUseStationPanel = () => {
        props.setShowimportData('block');
        props.setShowUseStationData('none');
        props.setFileCountData('block');
        props.setShowImportButton('block');
        props.importRemoveLocation();
        props.removeAllMapLocations();
        props.setSearchShowUseStationData('none');
    }

    const cancelUseStation = () => {
        props.setShowimportData('block');
        props.setShowUseStationData('none');
        props.setFileCountData('block');
        props.setShowImportButton('block');
        props.importRemoveLocation();
        props.removeAllMapLocations();
        props.setSearchShowUseStationData('none');
    }

    /* This Function is used for component will unmount start */
    const unmountFileUploaded = () => {
        // homeEvent();
        // props.setImportDataMapPoint(false);
        props.setDetails([]);
        props.setMapLocation([]);
        props.setShowFileList('none');
        props.setLoaderShow('block');
        props.setShowimportData('none');
        props.removeMatchLocation();
        props.getSearchWidget.disabled = false;
        props.removeAllMapLocations();
        if (props.geojsonLayer) props.geojsonLayer.visible = true;
    }

    const closeDataBlock = () => {
        props.setShowFileList('none');
        props.getSearchWidget.disabled = false;
        // This condition is to retain map data and station panel after import close
        if (props.importStationId && props.mapSelectedStationId) {
            props.getStationDetail(props.mapSelectedStationId);
            if (props.myGeoLayer && props.getFilteredStations) {
                props.mapView.add(props.myGeoLayer);
            } else if (props.searchParam) {
                props.setSearchChecked(true);
                props.geojsonLayer.visible = true;
            } else {
                props.geojsonLayer.visible = true;
            }
        } else {
            props.tempView.graphics.removeAll();
        }
    }
    /* This Function is used for component will unmount end */

    return (
        
      <div className={classes.fileListBlock} style={{ display: props.showFileList, height: blockHeight }} data-testid='fileListBlock' id='mainFileBlock-dev'>
      <Resizable
        style={style}
        defaultSize={{
          width: '100%',
          height: 'auto',
        }}
        enable={{ top: true, left: false, right: false, bottom: false, }}
        onResize={checkBlockHeight}
      >
        <p className={classes.resizeBlock}><span>=</span></p>
        <h3>Import Data</h3>
        <img src={require('../../../assets/images/hrimg.svg')} style={{ marginBottom: '5px' }} className={classes.borderImg} />
        {props.details.length <= API_PATH.fileUploadLimit && props.importResponceValue == 0 ?
          <p style={{ marginBottom: '5px', marginTop: '0', display: props.fileCountData }}>Showing {props.details.length} of {props.details.length} files to be imported</p>
          : null}
        {props.details.length > API_PATH.fileUploadLimit && props.importResponceValue == 0 ?
          <p style={{ marginBottom: '5px', marginTop: '0', display: props.fileCountData }}>Showing {API_PATH.fileUploadLimit} of {API_PATH.fileUploadLimit} files to be imported</p>
          : null}
        <div className="importList-left" style={
          props.details.length > 6 ? { overflowY: 'scroll', maxHeight: autoAdjustHeight + 'px' }
            : null}>
          {props.details.length == 0 && props.importResponceValue === 2 ?
            <p className={classes.importedMsg}><FontAwesomeIcon icon={faCheckCircle} />The files have been successfully imported to DataPoint</p>
            : null}
          {props.details.length > 0 && props.importResponceValue === 1 ?
            <p className={classes.importedErrorMsg}><FontAwesomeIcon icon={faExclamationCircle} />{fileUploadError}</p>
            : null}
          <div className={classes.loaderBlock} style={{ display: props.loaderShow }}>
            <div className="loader-left">
              <img src={require('../../../assets/images/loaderImg.gif')} className={classes.loaderImg} />
            </div>
            <div className="loader-right">
              <p>Getting files ready to import...</p>
            </div>
          </div>
          <div className={classes.loaderBlock} style={{ display: importloaderShow }}>
            <div className="loader-left">
              <img src={require('../../../assets/images/loaderImg.gif')} className={classes.loaderImg} />
            </div>
            <div className="loader-right">
              <p>Uploading Files...</p>
            </div>
          </div>
          {props.details.length > 0 ? <>
            <div style={{ display: props.showimportData, width: '100%', float: 'left' }}>
              <table className={classes.importedFilesTable}>
                <thead>
                  <tr>
                    <th style={{ width: '10%' }}>Status</th>
                    <th style={{ width: '5%', textAlign: 'center' }}><span title='Data import availablability' style={{ cursor: 'pointer' }}><CloudQueueIcon className={classes.fileIcon} /></span></th>
                    <th style={{ width: '30%' }}>File Name</th>
                    <th style={{ width: '15%' }}>Station ID</th>
                    <th style={{ width: '15%' }}>Vendor</th>
                    <th style={{ width: '20%' }}>Data Type</th>
                    <th style={{ width: '5%' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    props.details.slice(0, API_PATH.fileUploadLimit).map((detail, index) => (
                      <tr key={index}>
                        {detail.import_Status == 'ready' ?
                          <>
                            <td style={{ width: '10%' }}>{detail.status}</td>
                            <td style={{ width: '5%', textAlign: 'center' }}>{detail.dataType == 'File Storage' ? <span title='Data import not supported' style={{ cursor: 'pointer' }}><InsertDriveFileOutlinedIcon className={classes.fileIcon} /></span> : <span title='Data import supported' style={{ cursor: 'pointer' }}><CloudQueueIcon className={classes.fileIcon} /></span>}</td>
                            <td style={{ width: '30%' }}>{detail.fileName}</td>
                            <td style={{ width: '15%' }}>
                              {detail.file_status == 'success' && detail.file_size_status == 'success' ?                               
                                <p className={classes.locationPara}><span className={classes.locationIconSuccess} onClick={() => { props.callLocations(index) }} title='Locate Station'><RoomIcon /></span><input type='text' defaultValue={st_cl_id} name={'stationId_text_input_success' + index} id={'stationId_text_input_success' + index} value={detail.sationId} onChange={(e) => { onInputChange(e, index) }} className='successinput' /><FontAwesomeIcon icon={faCheck} className='checkedIcom' /></p>
                                : detail.file_status == 'error' && detail.file_size_status == 'success' ?
                                  <p className={classes.locationPara}><span className={classes.locationIconError} onClick={() => { props.callLocations(index) }} title='Locate Station'><RoomIcon /></span><input type='text' defaultValue={st_cl_id} name={'stationId_text_input_error' + index} id={'stationId_text_input_error' + index} onChange={(e) => { onInputChange(e, index) }} value={detail.sationId == '' ? '' : detail.sationId} /><span style={{ display: 'none' }}>{importBtnStatus = 0}</span></p>
                                  : <p className={classes.locationParaSizeExceeds} style={{ pointerEvents: 'none' }}><span className={classes.locationIconErrorSizeExceeds} onClick={() => { props.callLocations(index) }} title='Locate Station'><RoomIcon /></span><input type='text' defaultValue={st_cl_id} name={'stationId_text_input_' + index} id={'stationId_text_input_' + index} onChange={(e) => { onInputChange(e, index) }} /><span style={{ display: 'none' }}>{importBtnStatus = 0}</span></p>}
                            </td>
                            <td style={{ width: '15%' }}>{detail.vendor}</td>
                            <td style={{ width: '20%' }}>{detail.dataType}</td>
                            <td style={{ width: '5%', textAlign: 'center', padding: '0' }}><NavLink className={classes.removeIcon} to="#" onClick={(e) => { removeRow(e, index) }} title='Remove'><FontAwesomeIcon icon={faTimes} className={classes.removeIcon} /></NavLink></td>
                          </> : null}

                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div><div style={{ display: props.showUseStationData, width: '100%', float: 'left' }}>
              <p style={{ marginBottom: '10px', marginTop: '0' }} ><NavLink to="#" style={{ color: '#24618E' }} onClick={returnUseStationPanel} ><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to Station List</NavLink></p>
              <div className={classes.useStationDataBlockLeft}>
                <p><span className='span-left'>Station ID:</span><span className='span-right'>{props.useStationId}</span></p>
                <p><span className='span-left'>Station Location:</span><span className='span-right'>{props.useStationLocation}</span></p>
                <p><span className='span-left'>Lat / Long:</span><span className='span-right'>{props.useStationLat}, {props.useStationLong}</span></p>
                <p><span className='span-left'>Status:</span><span className='span-right useStatusCaps'>{props.useStationStatus}</span></p>
              </div>
              <div className={classes.useStationDataBlockRight}>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button type="button" variant="outlined" id="cancel_useStation_btn" className={classes.cancelUseThisStation} onClick={cancelUseStation}>
                  Cancel</Button></p>
                <p >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button type="submit" variant="outlined" id="useThis_station_btn" className={classes.useThisStationBtn} onClick={props.useThisStationDataStation} data-testid='useStationBtn'>
                  Use This Station</Button></p>
              </div>
            </div></> : null}
        </div>
        <div className="importList-right">
          <div style={{ width: '100%', float: 'left', display: props.showImportButton }} >
            <p style={{ marginTop: '0' }}><NavLink to={`/UsersDashboard?import=` + 1} variant="outlined" id="cancel_btn" className={classes.addMoreBtnMain} data-testid='addMoreFilesBtn'>
              Add More Files</NavLink></p>
            {props.importResponceValue == 0 || props.importResponceValue == 1 && props.details.length > 0 ?
              <>
                <p style={{ marginTop: '50px' }}><Button type="button" variant="outlined" id="add_more_btn" className={classes.importDatabtn} onClick={unmountFileUploaded} data-testid='cancelBtn' >
                  Cancel</Button></p>
                <p>{importBtnStatus == 0 || props.details.length == 0 || importloaderShow === 'block' ? <Button type="submit" variant="outlined" id="import_data_btn" className={classes.aadMoreFilesDesabled} onClick={importFileData} disabled data-testid='importDataBtn'>
                  Import Data</Button> : <Button type="submit" variant="outlined" id="import_data_btn" className={classes.aadMoreFiles} onClick={importFileData} data-testid='importDataBtn'>
                    Import Data</Button>}</p>
              </> : <p><Button type="button" variant="outlined" id="close_data_btn" className={classes.aadMoreFiles} onClick={closeDataBlock}>
                Close</Button> </p>}
          </div>
        </div>
      </Resizable>
    </div>

    )
}

export default ImportList;